// extracted by mini-css-extract-plugin
export default {"tableHeaderOptionsButton":"_31H1o9MzJ__RlSWgJ82W5L"};